import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import { Timer } from 'three/addons/misc/Timer.js'
import World from './World.js'

let renderer, canvas, scene, camera, controls, world;

canvas = document.querySelector('canvas.webgl')

window.addEventListener('resize', () => {
    camera.aspect = window.innerWidth / window.innerHeight
    camera.updateProjectionMatrix()

    renderer.setSize(window.innerWidth, window.innerHeight)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

const timer = new Timer()
const animateWorld = () => {
    timer.update()
    const elapsedTime = timer.getElapsed()

    world.moveGhosts(elapsedTime)

    controls.update()

    renderer.render(scene, camera)

    window.requestAnimationFrame(animateWorld)
}

function initializeWorld() {
    renderer = new THREE.WebGLRenderer({ canvas })
    renderer.setSize(window.innerWidth, window.innerHeight)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
    renderer.shadowMap.enabled = true
    renderer.shadowMap.type = THREE.PCFSoftShadowMap

    scene = new THREE.Scene();
    camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 0.1, 100)
    camera.position.x = 4
    camera.position.y = 3
    camera.position.z = 6
    scene.add(camera)
    
    // Controls
    controls = new OrbitControls(camera, canvas)
    controls.minDistance = 3
    controls.maxDistance = 10
    controls.minPolarAngle = 0;
    controls.maxPolarAngle = Math.PI * 0.45;
    controls.enableDamping = true

    renderer.setSize(window.innerWidth, window.innerHeight);
    document.body.appendChild(renderer.domElement);

    world = new World(scene)
    world.init()

    animateWorld();
}
initializeWorld();
